import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {
  AdminLayoutComponent,
  ApplicantLayoutComponent,
  ErrorPageComponent,
  RedirectComponent,
} from './components';
import { AppCustomPreloader } from './strategy';
import { AuthenticationGuard } from './guards/authentication';
import { AdminAuthGuard } from './guards/admin';
import { ContractorAuthGuard } from './guards/contractor';
const routes: Routes = [
  {
    path: 'contractor',
    data: { preload: true, title: 'NCC Eservices' },
    loadChildren: () =>
      import('../features/contractor/contractor.module').then(
        (m) => m.ContractorModule
      ),
  },
  {
    path: '',
    redirectTo: 'home-page',
    pathMatch: 'full',
  },
  {
    path: 'redirect',
    component: RedirectComponent,
  },
  {
    path: 'home-page',
    data: { preload: true },
    loadChildren: () =>
      import('../features/public/public.module').then((m) => m.PublicModule),
  },
  {
    path: '',
    component: AdminLayoutComponent,
    canLoad: [AuthenticationGuard, AdminAuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'admin',
        pathMatch: 'full',
      },
      {
        path: 'admin',
        data: { preload: true, title: 'NCC Eservices' },
        component: ApplicantLayoutComponent,
        loadChildren: () =>
          import('../features/admin/admin.module').then((m) => m.AdminModule),
      },
      {
        path: 'notifications',
        data: { preload: true, title: 'NCC Eservices' },
        component: ApplicantLayoutComponent,
        loadChildren: () =>
          import('../features/notification/notification.module').then(
            (m) => m.NotificationModule
          ),
      },
    ],
  },
  // wild card route for not found error
  {
    path: '**',
    pathMatch: 'full',
    component: ErrorPageComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: false,
      onSameUrlNavigation: 'reload',
      preloadingStrategy: AppCustomPreloader,
    }),
  ],
  exports: [RouterModule],
  providers: [AppCustomPreloader],
})
export class CoreRoutingModule {}
